import React from 'react';
import classNames from 'classnames';

import Button from 'components/partials/button/button';

import FilterTag from './filter-tag';

import { hasAnyFundsFilter } from '../helpers/funds-filters.helpers';

import {
  FUND_SOURCE_OPTIONS,
  FUND_TYPE_OPTIONS,
} from '../funds-step.constants';

import type { FundsFilterValues } from '../funds-step.types';

interface AppliedFiltersBarProps {
  values: FundsFilterValues;
  onRemove: (field: keyof FundsFilterValues, value?: string) => void;
  onClearAll: () => void;
  className?: string;
}

const getOptionLabel = (
  options: { value: string; label: string }[],
  value: string
): string => options.find((option) => option.value === value)?.label ?? value;

const AppliedFiltersBar = ({
  values,
  onRemove,
  onClearAll,
  className,
}: AppliedFiltersBarProps) => {
  if (!hasAnyFundsFilter(values)) {
    return null;
  }

  return (
    <div
      className={classNames(
        'flex items-center gap-3 shrink-0 flex-wrap',
        className
      )}
      data-testid="applied-filters-bar"
    >
      <span className="text-sm font-semibold text-gray-700">
        Applied filters:
      </span>
      <div className="flex items-center gap-3 flex-wrap">
        {values.source.map((source) => (
          <FilterTag
            key={`source-${source}`}
            label={`Source: ${getOptionLabel(FUND_SOURCE_OPTIONS, source)}`}
            onRemove={() => onRemove('source', source)}
          />
        ))}
        {values.type.map((type) => (
          <FilterTag
            key={`type-${type}`}
            label={`Type: ${getOptionLabel(FUND_TYPE_OPTIONS, type)}`}
            onRemove={() => onRemove('type', type)}
          />
        ))}
        {values.instAid !== null && (
          <FilterTag
            label={`Inst. aid: ${values.instAid ? 'Yes' : 'No'}`}
            onRemove={() => onRemove('instAid')}
          />
        )}
        {values.totalAid !== null && (
          <FilterTag
            label={`Total aid: ${values.totalAid ? 'Yes' : 'No'}`}
            onRemove={() => onRemove('totalAid')}
          />
        )}
        <Button
          type="button"
          variant="reserve-text-link"
          size="sm"
          onClick={onClearAll}
          data-testid="clear-all-filters"
        >
          Clear All
        </Button>
      </div>
    </div>
  );
};

export default AppliedFiltersBar;
